import { Component } from '@angular/core';

@Component({
  selector: 'iris-card-body',
  templateUrl: './iris-card-body.component.html',
  styleUrls: ['./iris-card-body.component.css'],
  standalone: false,
})
export class IrisCardBodyComponent {}
